import {defineField, defineType} from 'sanity'
import {MdOutlineAutoAwesomeMosaic} from 'react-icons/md'

export default defineType({
  name: 'posts-by-tag',
  title: 'Posts by Tag',
  type: 'object',
  icon: MdOutlineAutoAwesomeMosaic,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      description: 'if title is not provided, the tag title will be used',
    }),
    defineField({
      name: 'tag',
      type: 'reference',
      to: [{type: 'blog.tag'}],
    }),
    defineField({
      name: 'limit',
      description: 'Number of posts to display',
      type: 'number',
      initialValue: 6,
      validation: (Rule) => Rule.min(1),
    }),
  ],
  preview: {
    select: {
      title: 'title',
      tagTitle: 'tag.title',
    },
    prepare: ({title, tagTitle}) => {
      return {
        title: title || tagTitle,
      }
    },
  },
})
